<template>
  <div ref="priceSection" class="price-section">
    <div class="price-section-content">
      <div class="head">
        <div class="title">价格区间</div>
      </div>
      <div class="price" @click="onClickPrice">
        <div class="low common">
          <input
            type="tel"
            v-model.trim="startPrice"
            placeholder="最低价"
            @input="onInputStartPrice"
            @focus="onFcousStartPrice"
            @blur="onBlurStartPrice"
          >
        </div>
        <div class="line"></div>
        <div class="high common">
          <input
            type="tel"
            v-model.trim="endPrice"
            placeholder="最高价"
            @input="onInputEndPrice"
            @focus="onFcousEndPrice"
            @blur="onBlurEndPrice"
          >
        </div>
      </div>
      <!-- <div class="content">
        <div class="periods">
          <div class="price-top">23-93</div>
          <div class="price-bottom">30%选择</div>
        </div>
        <div class="periods">
          <div class="price-top">23-93</div>
          <div class="price-bottom">30%选择</div>
        </div>
        <div class="periods">
          <div class="price-top">23-93</div>
          <div class="price-bottom">30%选择</div>
        </div>
      </div>-->
    </div>
    <div class="price-section-base"></div>
  </div>
</template>

<script>
export default {
  name: 'PriceSection',
  components: {},
  data() {
    return {
      startPrice: '',
      endPrice: ''
    };
  },
  props: {
    searchData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {},
  created() {
    this.update();
  },
  methods: {
    onClickPrice(e) {
      e.stopPropagation();
    },
    processData(startPrice, endPrice) {
      const rep = /^\d{0,8}$/;

      if (rep.test(startPrice) && rep.test(endPrice)) {
        // if (startPrice > endPrice) {
        //   endPrice = startPrice;
        // }

        this.startPrice = startPrice;
        this.cacheStartPrice = startPrice;

        this.endPrice = endPrice;
        this.cacheEndPrice = endPrice;
      } else {
        this.startPrice = this.cacheStartPrice;
        this.endPrice = this.cacheEndPrice;
      }
    },
    onClickReset() {
      this.startPrice = '';
      this.endPrice = '';
      this.cacheStartPrice = '';
      this.cacheEndPrice = '';
    },
    update() {
      let _startPrice = this.searchData.startPrice || '';
      let _endPrice = this.searchData.endPrice || '';

      this.processData(_startPrice, _endPrice);
    },
    onInputStartPrice() {
      this.processData(this.startPrice, this.endPrice);
    },
    onInputEndPrice() {
      this.processData(this.startPrice, this.endPrice);
    },
    onFcousStartPrice(e) {
      this.$emit('onFcousStartPrice', e);
    },
    onFcousEndPrice(e) {
      this.$emit('onFcousEndPrice', e);
    },
    onBlurStartPrice(e) {
      this.$emit('onBlurStartPrice', e);
    },
    onBlurEndPrice(e) {
      this.$emit('onBlurEndPrice', e);
    }
  },
  mounted() {},
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>

<style lang="scss">
@import '@/scss/mixin.scss';
.price-section {
  width: 100%;
  .price-section-content {
    width: 100%;
    padding: $rem30 0 $rem30 $rem24;
    .head {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: left;
      margin-bottom: $rem30;
      .title {
        font-family: PingFangSC-Medium;
        font-size: $rem32;
        line-height: $rem32;
        color: #222222;
        letter-spacing: 0;
        margin-right: $rem10;
        //margin-bottom: $rem30;
      }
    }
    .price {
      width: 100% !important;
      display: flex;
      flex-direction: row;
      justify-content: left;
      align-items: center;
      padding-right: $rem24;
      //margin-bottom: $rem26;
      overflow-x: hidden;
      .common {
        height: $rem74;
        line-height: $rem74;
        background: #f7f7f7;
        border-radius: 100px;
        flex: 1;
        font-family: PingFangSC-Regular;
        font-size: $rem24;
        color: #cccccc;
        letter-spacing: 0;
        text-align: center;

        input {
          border-radius: 100px;
          width: 100% !important;
          height: 100% !important;
          background: #f7f7f7;
          text-align: center;
        }
      }
      .line {
        opacity: 0.55;
        background: #333333;
        width: $rem20;
        height: $rem2;
        margin: 0 $rem21;
      }
    }
    .content {
      display: flex;
      flex-direction: row;
      justify-content: left;

      .periods {
        margin-right: $rem24;
        flex: 1;
        font-family: PingFangSC-Regular;
        color: #333333;
        letter-spacing: 0;
        text-align: center;
        background: #f7f7f7;
        border-radius: $rem100;
        padding: $rem10 0;
        .price-top {
          font-family: PingFangSC-Regular;
          font-size: $rem24;
          color: #333333;
          letter-spacing: 0;
          text-align: center;
          line-height: $rem26;
          margin-bottom: $rem8;
        }
        .price-bottom {
          font-family: PingFangSC-Regular;
          font-size: $rem20;
          color: #666666;
          letter-spacing: 0;
          text-align: center;
          line-height: $rem20;
        }
      }
    }
  }
  .price-section-base {
    width: 100%;
    background: #f7f7f7;
    height: $rem20;
  }
}
</style>
